import { useEffect, useState } from 'react'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { clientServices } from 'src/services/auth/client/client.service'
import { required, useGetIdentity, useNotify, useTranslate } from 'react-admin'
import { Skeleton } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'

export const WrapperClient = ({ index, setList, item, id, setSelectedHashClient}) => {
  const translate = useTranslate()
  const notify = useNotify()
  const { identity } = useGetIdentity()
  const [isLoadingClient, setLoadingClient] = useState(false)

  useEffect(() => {
    ;(async () => {
      try {
        setLoadingClient(true)
        const allClients = await clientServices.getByAll()
        if (!allClients) {
          notify('ra.notification.clientsNotFound', { type: 'error' })
          setLoadingClient(false)
          return
        }

        const setValue = (value) => {
          return {
            optionsClient: allClients,
            checkedClient: value.clients.checkedClient,
          }
        }

        setList((prev) => prev.map((item) => (item.id === id ? { ...item, clients: setValue(item) } : item)))

        setLoadingClient(false)
      } catch (error) {
        setLoadingClient(false)
        notify('ra.notification.clientsNotFound', { type: 'error' })
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onClientChange = (e) => {
    const newVal = e.target.value
    const setAndRestoreItem = (item) => {
      setSelectedHashClient(item?.clients?.optionsClient?.find(cli=>cli.id === newVal)?.hash_client ?? null)
      return {
        ...item,
        id: item.id,
        clients: {
          optionsClient: item.clients.optionsClient,
          checkedClient: newVal,
        },
        applications: { optionsApplication: [], checkedApplication: '' },
        roles: { optionsRole: [], selectedRole: [] },
      }
    }

    setList((prev) => prev.map((item) => (item.id === id ? setAndRestoreItem(item) : item)))
  }

  if (identity?.is_superadmin) {
    return (
      <EditInputsWrap label={translate('ra.field.client')} md={12} required>
        {isLoadingClient ? (
          <Skeleton variant='rectangular' width={'100%'} height={40} />
        ) : (
          <SelectInput
            source={`aplications[${index}].client_id`}
            options={item.clients.optionsClient}
            defaultValue={item.clients.checkedClient}
            onChange={onClientChange}
            fullWidth
            optionsText={['long_name']}
            validate={[required()]}
          />
        )}
      </EditInputsWrap>
    )
  }
}
